import api from './request'

const loginById = userId => {
    return api.getPromise('user/info', {userId})
}

const userIdLogin = token => {
    return api.getPromise('login/userIdLogin', {token})
}

export default {
    loginById,
    userIdLogin,
}


// WEBPACK FOOTER //
// ./src/request/userApi.js